var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-footer-wrap" }, [
    _c("div", { staticClass: "app-footer-holder" }),
    _c("div", { staticClass: "app-footer" }, [
      _c("div", { staticClass: "app-footer__inner" }, [
        _c("div", { staticClass: "app-footer__contact" }, [
          _c("span", { staticClass: "app-footer__item" }, [
            _vm._v("客服邮箱：" + _vm._s(_vm.configdata.maile)),
          ]),
          _c("i", { staticClass: "app-footer__sep" }),
          _c("span", { staticClass: "app-footer__item" }, [
            _vm._v("联系电话：" + _vm._s(_vm.configdata.servicephone)),
          ]),
          _c("i", { staticClass: "app-footer__sep" }),
          _c("span", { staticClass: "app-footer__item" }, [
            _vm._v("工作日 9:00-18:00"),
          ]),
        ]),
        _c("div", { staticClass: "app-footer__line" }),
        _c("div", { staticClass: "app-footer__meta" }, [
          _c("span", { staticClass: "app-footer__item" }, [
            _vm._v(
              "Copyright © 2019-2025 西安盛唐启航信息科技有限公司 ALL Rights Reserved 版权所有"
            ),
          ]),
          _c(
            "a",
            {
              staticClass: "app-footer__item",
              attrs: {
                target: "_blank",
                href: "https://beian.miit.gov.cn/#/Integrated/index",
              },
            },
            [_vm._v("工信部备案号：" + _vm._s(_vm.configdata.sitebeian))]
          ),
          _c(
            "span",
            { staticClass: "app-footer__item app-footer__item--police" },
            [
              _c("img", { attrs: { src: _vm.police, alt: "" } }),
              _vm._v(
                "公安网备案号：" + _vm._s(_vm.configdata.policebeiansn) + " "
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }